import { Route, Routes } from "react-router-dom";
// import FacultyReport from "./UnivDataComponents/FacultyReport";
// import UniversitySubjectFacReport from "./UnivDataComponents/UniversitySubjectFacReport";
// import UnivwiseReport from "./UnivDataComponents/UnivwiseReport";
// import UniversityWiseSubAndFacultyRepo from "./UnivDataComponents/UniversityWiseSubAndFacultyRepo";
// import AddUniversityDtls from "./UnivDataComponents/AddUniversityDtls";

// import SubjectWiseFacultyData from "./UnivDataComponents/SubjectWiseFacultyData";
// import AddDepartment from "./UnivDataComponents/AddDepartment";
// import UniversityFacultyData from "./UnivDataComponents/UniversityFacultyData";
// import FacultydetailsEdit from "./UnivDataComponents/FacultydetailsEdit";
// import SubjectwiseReport from "./UnivDataComponents/SubjectwiseReport";

// import ForgotPassword from "./ForgotPassword";
// import SubjectConsolidatedReport from "./UnivDataComponents/SubjectConsolidatedReport";
// import DeptWiseStatusReport from "./UnivDataComponents/DeptWiseStatusReport";
import RegistrationForm from "./Student Services/StuServices/RegistrationForm";
import StudentDetailsForm from "./Student Services/StuServices/StudentDetailsForm";
import RusaDashboard from "./UnivDataComponents/Dashboard";
import LoginPage from "./UnivDataComponents/LoginPage";
import MainDashboard from "./UnivDataComponents/MainDashboard";
import MenuBar from "./UnivDataComponents/MenuBar";
import ChangePassword from "./ChangePassword";
import StudentCompletionTabs from "./Student Services/StuServices/StudentCompletionTabs";
import PaymentForm from "./Payment/Payment";
import StudentDocumentUpload from "./StudentTransfersWorkFlow/StudentDocumentUpload";
import Test from "./Test";
import StudentsTransferTable from "./StudentTransfersWorkFlow/StudentsTransferTable";
import SuperAdminDetails from "./StudentTransfersWorkFlow/SuperAdminDetails";
import PaymentSuccess from "./Payment/PaymentSuccess";
import DownloadProceedings from "./StudentTransfersWorkFlow/DownloadProceedings";
import NocForm from "./CollegeServices/NocForm";
import StudentStatusReport from "./Student Services/StuReports/StudentStatusReport";
import StudentOverallStatusReport from "./Student Services/StuReports/StudentOverallStatusReport";
import RejectNoc from "./CollegeServices/RejectNoc";
import EntryOfAdmissionData from "./StudentTransfersWorkFlow/EntryOfAdmissionData";
import CollegesAdmissionDetailsReport from "./StudentTransfersWorkFlow/CollegesAdmissionDetailsReport";
import OCIAdmissions from "./Student Services/StuServices/OCIAdmissions";
import OciAdmissionDetailsReport from "./Student Services/StuReports/OciAdmissionDetailsReport";
import RequireAuth from "./RequireAuth";
import Unauthorized from "./Unauthorized";
import Status from "./CommonUtils/ESIGN/Status";
import Grievance from "./Grievance/Grievance";
import GrievanceReport from "./Grievance/GrievanceReport";
import StatusofCollege from "./StudentTransfersWorkFlow/StatusofCollege";
import WorkflowStatusReport from "./Student Services/StuReports/WorkFlowStatusReport";
const RoutesComponent = () => (
    <Routes>
        {/* <Route path="/Universiyedit" element={<MenuBar><UniversityFacultyData /></MenuBar>} />
        <Route path="/SubjectWiseFacultyData" element={<MenuBar><SubjectWiseFacultyData /></MenuBar>} />
        <Route path="/AddDepartment" element={<MenuBar><AddDepartment /></MenuBar>} />
        <Route path="/FacultyReport" element={<MenuBar><FacultyReport /></MenuBar>} />
        <Route path="/UniversitySubjectFacReport" element={<MenuBar><UniversitySubjectFacReport /></MenuBar>} />
        <Route path="/UnivwiseReport" element={<MenuBar><UnivwiseReport /></MenuBar>} />
        <Route path="/UniversityWiseSubAndFacultyRepo" element={<MenuBar><UniversityWiseSubAndFacultyRepo /></MenuBar>} />
        <Route path="/AddUniversityDtls" element={<MenuBar><AddUniversityDtls /></MenuBar>} />
        <Route path="/SubjectwiseReport" element={<MenuBar><SubjectwiseReport /></MenuBar>} />
        <Route path="/DeptWiseStatusReport" element={<MenuBar><DeptWiseStatusReport /></MenuBar>} />
        <Route path="/SubjectConsolidatedReport" element={<MenuBar><SubjectConsolidatedReport /></MenuBar>} />
        <Route path="/UniversityFacultyData" element={<MenuBar><FacultydetailsEdit /></MenuBar>} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} /> */}

        {/* ........STUDENT SERVICES........... */}
        <Route path="/RusaDashboard" element={<RusaDashboard />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/test" element={<Test />} />
        <Route path="/RegistrationForm" element={<RegistrationForm />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/esignresponse/Status" element={<Status />} />

        <Route element={<RequireAuth />}>

            <Route path="/home" element={<MenuBar><MainDashboard /></MenuBar>} />
            <Route path="/ChangePassword" element={<MenuBar><ChangePassword /></MenuBar>} />
            <Route path="/StudentDetailsForm" element={<MenuBar><StudentCompletionTabs /></MenuBar>} />
            <Route path="/StudentVerification" element={<MenuBar><StudentsTransferTable /></MenuBar>} />
            <Route path="/StudentFormReceiving" element={<MenuBar><StudentsTransferTable /></MenuBar>} />
            <Route path="/StudentDetails" element={<MenuBar><StudentsTransferTable /></MenuBar>} />
            <Route path="/StudentsDigisign" element={<MenuBar><SuperAdminDetails /></MenuBar>} />
            <Route path="/afflPaymentSucces/:id" element={<MenuBar><PaymentSuccess /></MenuBar>} />
            <Route path="/DownloadProceedings" element={<MenuBar><DownloadProceedings /></MenuBar>} />
            <Route path="/NOCForm" element={<MenuBar><NocForm /></MenuBar>} />
            <Route path="/StudentStatusReport" element={<MenuBar><StudentStatusReport /></MenuBar>} />
            <Route path="/StudentOverallStatusReport" element={<MenuBar><StudentOverallStatusReport /></MenuBar>} />
            <Route path="/RejectNoc" element={<MenuBar><RejectNoc /></MenuBar>} />
            <Route path="/EntryOfAdmissionData" element={<MenuBar><EntryOfAdmissionData /></MenuBar>} />
            <Route path="/CollegesAdmissionDetailsReport" element={<MenuBar><CollegesAdmissionDetailsReport /></MenuBar>} />

            <Route path="/OCIAdmissionsForm" element={<MenuBar><OCIAdmissions /></MenuBar>} />
            <Route path="/OCIAdmissions" element={<MenuBar><OciAdmissionDetailsReport /></MenuBar>} />
            <Route path="/RaiseYourConcern" element={<MenuBar><Grievance /></MenuBar>} />
            <Route path="/GrievanceReport" element={<MenuBar><GrievanceReport /></MenuBar>} />
            <Route path="/StatusofCollege" element={<MenuBar><StatusofCollege /></MenuBar>} />
            <Route path="/StatusReport" element={<MenuBar><WorkflowStatusReport /></MenuBar>} />


            {/* <Route path="/StudentCompletionTabs" element={<MenuBar><StudentCompletionTabs /></MenuBar>} /> */}
            {/* <Route path="/PaymentForm" element={<MenuBar><PaymentForm /></MenuBar>} /> */}
            {/* <Route path="/StudentDocumentUpload" element={<MenuBar><StudentDocumentUpload /></MenuBar>} /> */}
        </Route>
    </Routes>
);

export default RoutesComponent;